import React, { FC, useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import { useLazyQuery, useSubscription } from "@apollo/client";
import { ADITOR_SCENE_NOTIFICATION } from "../../../graphql/subscriptions";
import { ADITOR_IS_LATEST_SCENE } from "../../../graphql/queries";

interface Props {
    revisionId: number;
    aditorSceneId: number;
}

export const LatestSceneBadge: FC<Props> = ({ revisionId, aditorSceneId }) => {
    const [isLatestState, updateIsLatestState] = useState(true);

    useSubscription(ADITOR_SCENE_NOTIFICATION, {
        variables: { revisionId: Number(revisionId) },
        onData: ({ data: { data: { aditorSceneNotification } = {} } }) => {
            const result = aditorSceneNotification;
            console.log("[DEBUG] result ", result);
        }
    });

    const [isLatestScene, data] = useLazyQuery(ADITOR_IS_LATEST_SCENE, {
        variables: {
            revisionId: Number(revisionId),
            sceneId: Number(aditorSceneId)
        },
        fetchPolicy: "network-only"
    });

    useEffect(() => {
        isLatestScene();
    }, []);

    useEffect(() => {
        if (data && data.data?.isLatestScene) {
            updateIsLatestState(data.data.isLatestScene.success);
        }
    }, [data]);

    return (
        <>
            {isLatestState ? null : (
                <Badge
                    className="mx-2"
                    title="Current scene is out of date!"
                    bg="warning"
                >
                    Scene out of date!
                </Badge>
            )}
        </>
    );
};
